/* eslint-disable no-dupe-keys */
export default {
  user_statistics: {
    titles: {
      // 统计面板
      dashboard: '用户统计面板',
      time_group_statistics: '按时间(趋势)统计',
      prop_group_statistics: '按属性(充电站)统计',
      // 按时间分组统计
      statistics_new_users_count: '新用户统计',
      statistics_charge_users_count: '充电用户统计'
      // 按属性分组统计
    },
    legends: {
      new_users_count: '新注册用户(人)',
      new_users_conversion: '新用户转化充电(人)',
      first_charge_users_count: '统计时间内首次充电(人)',
      charge_users_count: '充电用户(人)'
    },
    labels: {
      group_by: '统计项',
      prop_statistics_time: '注册时间/首次充电',
      statistics_time: '统计时间'
    },
    // 分组类型
    prop_group_types: {
      first_ev_charging_station: '按首次充电的站点'
      // car_usage: '车辆使用性质'
    }
  }
}
